// src/services/dashboard/dashboard.mapper.ts
import type { Layout, Layouts } from "react-grid-layout";
import type { Breakpoint, DashboardWidget } from "../../types/dashboard/dashboard.types";

export const colsByBreakpoint: Record<Breakpoint, number> = {
  lg: 12,
  md: 10,
  sm: 6,
  xs: 4,
  xxs: 2,
};

export function normalizeWidgets(raw: any[]): DashboardWidget[] {
  // mapping id_widget -> id (string) comme dans ton code :contentReference[oaicite:9]{index=9}
  const widgetsWithId: DashboardWidget[] = raw.map((w: any) => ({
    ...w,
    id: String(w.id_widget),
  }));

  // validation x+w <= cols lg (comme ton code) :contentReference[oaicite:10]{index=10}
  return widgetsWithId.map((w) => {
    if (w.x + w.w > colsByBreakpoint.lg) {
      w.w = colsByBreakpoint.lg - w.x;
    }
    return w;
  });
}

export function buildLayoutsFromWidgets(widgets: DashboardWidget[]): Layouts {
  // exactement la construction lg/md/sm/xs/xxs de ton fichier :contentReference[oaicite:11]{index=11}
  return {
    lg: widgets.map((w) => ({ i: w.id, x: w.x, y: w.y, w: w.w, h: w.h })),
    md: widgets.map((w) => ({ i: w.id, x: Math.floor(w.x / 2), y: w.y, w: Math.floor(w.w / 2) || 1, h: w.h })),
    sm: widgets.map((w) => ({ i: w.id, x: Math.floor(w.x / 3), y: w.y, w: Math.floor(w.w / 3) || 1, h: w.h })),
    xs: widgets.map((w) => ({ i: w.id, x: Math.floor(w.x / 4), y: w.y, w: Math.floor(w.w / 4) || 1, h: w.h })),
    xxs: widgets.map((w) => ({ i: w.id, x: 0, y: Math.floor(w.y / 5), w: 1, h: w.h })),
  };
}

export function applyCurrentLayoutToWidgets(
  currentLayout: Layout[],
  widgets: DashboardWidget[]
): DashboardWidget[] {
  // même logique que ton onLayoutChange :contentReference[oaicite:12]{index=12}
  return widgets.map((widget) => {
    const layout = currentLayout.find((l) => l.i === widget.id);
    if (!layout) return widget;
    return { ...widget, x: layout.x, y: layout.y, w: layout.w, h: layout.h };
  });
}

export function getDefaultWidth(breakpoint: Breakpoint): number {
  // même logique que ton getDefaultWidth :contentReference[oaicite:13]{index=13}
  switch (breakpoint) {
    case "lg":
      return 4;
    case "md":
      return 3;
    case "sm":
      return 2;
    case "xs":
    case "xxs":
      return 1;
    default:
      return 2;
  }
}
